import merge from 'lodash/merge'
import stylesGeneral from './CHeader.stylesGeneral'
import sidepanelStyles from './sidePanel.styles'
import { parseResponsiveProperty } from '@converdy/styles'

export default function headerStyles({
  general,
  transparent,
  sidePanel = {}
}) {

  const { height } = general

  let jss = {
    ...merge(
      stylesGeneral('& .funnel-header', general),
      {
        '& .mobile-side-panel': sidepanelStyles(sidePanel)
      }
      ),
      ...stylesGeneral('& .funnel-header.transparent:not(.scrolled.sticky)', transparent),
      '& .funnel-header.transparent': parseResponsiveProperty((c) => {
        return {'margin-bottom': `-${c.unit}${c.value}` }
        }, height)
  }  

  return jss
}
